import React, { useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import Label from "./LabelF";
import "react-datepicker/dist/react-datepicker.css";
//import "../filtros.scss";
import ar from "date-fns/locale/es";
import { parseISOString, getAtributo } from "../../../context/FuncionesContext";

import { TextField } from "@mui/material";
registerLocale("ar", ar);

function transformarFechaISOaMySQL(fechaISO) {
  try {
    if (
      fechaISO === null ||
      fechaISO === undefined ||
      fechaISO === "" ||
      isNaN(Date.parse(fechaISO))
    )
      return null;

    const fecha = new Date(fechaISO);
    const fechaMySQL = fecha.toISOString().replace("T", " ").replace("Z", "");
    return fechaMySQL;
  } catch (er) {
    console.log(er, fechaISO);
    return fechaISO;
  }
}

export const parseFechaFormato = (fechaFormato) => {
  const showTimeSelect =
    fechaFormato.includes("h") ||
    fechaFormato.includes("H") ||
    fechaFormato.includes("m");
  const showTimeSelectOnly =
    !fechaFormato.includes("d") &&
    !fechaFormato.includes("M") &&
    !fechaFormato.includes("y");
  let timeFormat = "";
  let timeIntervals = 60;

  // Verificar la presencia de horas, minutos y segundos en el formato
  if (fechaFormato.includes("hh") || fechaFormato.includes("HH")) {
    timeFormat += fechaFormato.includes("hh") ? "hh" : "HH"; // 12 horas o 24 horas
  }

  if (fechaFormato.includes("mm")) {
    timeFormat += timeFormat ? ":mm" : "mm"; // Añadir minutos si es necesario
    timeIntervals = 15;
  }

  if (fechaFormato.includes("ss")) {
    timeFormat += timeFormat ? ":ss" : "ss"; // Añadir segundos si es necesario
  }

  return {
    showTimeSelect,
    showTimeSelectOnly,
    timeFormat,
    dateFormat: fechaFormato,
    timeIntervals,
  };
};

const FechaSimple = (props) => {
  const { id_a, setValor, valor, grid_span, error, setError, cab, data } =
    props;

  const def = data[cab.id_a + "_default"] ?? cab.default;
  const permite_null =
    data[cab.id_a + "_permite_null"] === "s" || cab.permite_null === "s";

  const [fecha, setFecha] = useState("");

  const styles = {
    gridColumn: grid_span,
  };

  function validaFormatoFecha(valor) {
    const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    return regex.test(valor);
  }

  useEffect(() => {
    setFecha(parseISOString(valor));
    if (!valor && validaFormatoFecha(def)) {
      setFecha(parseISOString(def));
    }
    if (!valor) return setFecha(null);
  }, []);

  useEffect(() => {
    if (validaFormatoFecha(valor)) {
      setValor(transformarFechaISOaMySQL(valor));
    }
    if (!valor && def && validaFormatoFecha(def)) {
      setValor(def);
    }
  }, []);

  const handleChange = (date) => {
    if (!permite_null && date === null) return;
    setFecha(date);
    setError((e) => {
      return { ...e, [id_a]: false };
    });
    setValor(transformarFechaISOaMySQL(date));
  };

  const fecha_formato = (() => {
    if (props.fecha_formato && props.fecha_formato !== "")
      return props.fecha_formato;
    return cab.fecha_formato ?? "dd/MM/yyyy";
  })();

  const disabled = getAtributo("disabled", data, cab) === "s";
  const {
    showTimeSelect,
    showTimeSelectOnly,
    timeFormat,
    dateFormat,
    timeIntervals,
  } = parseFechaFormato(fecha_formato);

  return (
    <div style={styles}>
      <div
        className="filtro_grid_fecha"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Label
          label={cab.nombre}
          opcionales_null={cab.opcionales_null}
          permite_null={cab.permite_null}
        />
        <div style={{ display: "flex" }} className="fecha_simple_datepicker">
          <DatePicker
            timeFormat={timeFormat}
            timeIntervals={timeIntervals}
            timeCaption="Hora"
            dateFormat={dateFormat}
            locale="ar"
            selected={fecha}
            value={fecha}
            showYearDropdown={true}
            showTimeSelectOnly={showTimeSelectOnly}
            showTimeSelect={showTimeSelect}
            placeholderText={cab.placeholder ?? cab.fecha_formato}
            onChange={handleChange}
            customInput={
              <TextField
                className={error[id_a] ? "filtro_fecha_input_error" : " w-100"}
                label={
                  cab.label && cab.label.trim() !== "" ? cab.label : undefined
                }
              />
            }
            // isClearable
            // withPortal
            autoComplete="off"
            disabled={disabled}
          />{" "}
          {permite_null ? (
            <div
              onClick={() => handleChange(null)}
              className="columna_input_date_null"
            >
              x
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default FechaSimple;
